export default {
  state: {
    defaultData: {},
    examData: {},
    consult: {},
    consultExam: {},
  },

  getters: {
    getAgreementData(state) {
      return state.defaultData;
    },
    getConsultAgreementData(state) {
      return state.consult;
    },
    getConsultExamAgreementData(state) {
      return state.consultExam;
    },
    getAgreementExamData(state) {
      return state.examData;
    },
  },

  mutations: {
    setAgreementData(state, data) {
      const isNull = data === null;

      state.defaultData = {
        id: !isNull ? data.id : "",
        county: !isNull ? data.county.name : "",
        quant: !isNull ? data.quant : "",
      };
    },

    setConsultAgreementData(state, data) {
      const isNull = data === null;
      state.consult = {
        id: !isNull ? data.id : "",
        created_at: !isNull ? data.created_at : "",
        deleted_at: !isNull ? data.deleted_at : "",
        month: !isNull ? data.month : "",
        polyclinic_id: !isNull ? data.polyclinic_id : "",
        procedure: !isNull ? data.procedure : "",
        procedure_code: !isNull ? Number(data.procedure_code) : "",
        quant_total: !isNull ? data.quant_total : "",
        released: !isNull ? data.released : "",
        rn: !isNull ? data.rn : "",
        speciality: !isNull ? data.speciality : "",
        speciality_code: !isNull ? Number(data.speciality_code) : "",
        updated_at: !isNull ? data.updated_at : "",
        user_id: !isNull ? data.user_id : "",
        year: !isNull ? Number(data.year) : "",
        sex_id: !isNull ? Number(data.sex_id) : "",
      };
    },

    setConsultExamAgreementData(state, data) {
      const isNull = data === null;

      state.consultExam = {
        id: !isNull ? data.id : "",
        created_at: !isNull ? data.created_at : "",
        deleted_at: !isNull ? data.deleted_at : "",
        month: !isNull ? Number(data.month) : "",
        year: !isNull ? Number(data.year) : "",
        executingUnityCode: !isNull ? Number(data.executing_unity_id) : "",
        executingUnity: !isNull ? data.executing_unity : "",
        groupCode: !isNull
          ? data.pactuation_unity_group.map(item => item.group_exam_id)
          : [],
        groupData: !isNull ? data.pactuation_unity_group : [],
        examGroup: !isNull ? data.group_exam : "",
      };
    },

    setAgreementExamData(state, data) {
      const isNull = data === null;

      state.examData = {
        id: !isNull ? data.id : "",
        county: !isNull ? data.county.name : "",
        quant: !isNull ? data.quant : "",
      };
    },
  },

  actions: {
    changeAgreementData(context, infos) {
      context.commit("setAgreementData", infos);
    },
    changeConsultAgreementData(context, infos) {
      context.commit("setConsultAgreementData", infos);
    },
    changeConsultExamAgreementData(context, infos) {
      context.commit("setConsultExamAgreementData", infos);
    },
    changeAgreementExamData(context, infos) {
      context.commit("setAgreementExamData", infos);
    },
  },
};
